<template>
<div class="content-wrapper">
  <b-row>
    <b-col md="8">
      <h3 style="display: inline-block;padding-right: 5px;">{{company.name}}</h3>
      <label style="text-align: center; " :class="company.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'">{{ $t(company.status) }}</label>
    </b-col>
  </b-row>
  <br>
  <b-tabs content-class="bg-white" v-model="tabIndex">
    <b-tab :title="$t('Categories')" @click="fetchCategories" id="categories" active>
      <div class="col-12 bg-white p-4 float-left">
        <b-row>
          <b-col>
            <b-btn style="float:right;color:white;margin-bottom: 20px" variant="light" v-b-modal.modal-create-category>{{$t('Create Category')}}</b-btn>
          </b-col>
        </b-row>
        <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 25px;">
          <b-spinner
            variant="secondary"
          ></b-spinner>
        </div>
        <b-table
          show-empty
          hover
          small
          responsive
          :items="categories"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sort-compare="customCompare"
          @filtered="onFiltered"
        >
          <template v-slot:empty="scope">
            <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
          </template>
          <template v-slot:cell(id)="row">
            <b-link :append="true" class="nav-link" :to="{path: `/companies/${company.id}/category/${row.item.id}`, params: {tabIndex: tabIndex}}">{{ row.item.name }} </b-link>
          </template>
          <!--<template v-slot:cell(manager)="row">-->
            <!--<b-link v-if="row.item.managerId" :append="true" class="nav-link" :to="'/users/'+row.item.managerId">{{ row.item.managerName }} </b-link>-->
            <!--<b-link v-else @click="getCompanyManagerUsers(row.item.name)" v-b-modal.modal-assign-manager class="text-secondary">{{$t('Assign Manager')}}</b-link>-->
          <!--</template>-->
          <template v-slot:cell(managers)="row">
            <b-list-group flush v-if="row.item.managers">
              <b-list-group-item style="border-bottom: 0;background: unset;padding-top: 5px;padding-bottom: 5px;">
                <div style="line-height: 26px;" v-bind:key="manager.managerId" v-for="manager in row.item.managers">
                  <b-link :append="true" style="display: inline;padding-top: 5px;padding-bottom: 5px;" class="nav-link" :to="'/users/'+manager.managerId">{{ manager.managerName }} </b-link>
                  <b-link class="text-danger float-right" @click="removeManager(row.item.id, manager.managerId, manager.managerName)">Remove</b-link>
                </div>
              </b-list-group-item>
              <b-link v-if="row.item.managers.length < 3" @click="getCompanyManagerUsers(row.item.id)" v-b-modal.modal-assign-manager class="text-secondary">{{$t('Add Manager')}}</b-link>

            </b-list-group>
            <b-link v-else @click="getCompanyManagerUsers(row.item.id)" v-b-modal.modal-assign-manager class="text-secondary">{{$t('Assign Manager')}}</b-link>
          </template>
          <template v-slot:cell(actions)="row" >
            <b-button variant="outline-primary" size="sm" @click="editCategory(row.item)" class="mr-1">
              {{$t('Edit')}}
            </b-button>
            <b-button variant="outline-danger" size="sm" @click="deleteCategory(row.item, row.index)">
              {{$t('Delete')}}
            </b-button>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="categories.length"
          :per-page="perPage"
          align="center"
          class="my-5"
        ></b-pagination>
      </div>
    </b-tab>
    <b-tab :title="$t('Users')" @click="fetchUsers(false)" id="users">
      <div class="col-12 bg-white p-4 float-left">
        <b-row>
          <b-col lg="4" class="my-1">
            <b-form-group class="mb-0">
              <b-input-group size="sm">
                <b-form-input
                  v-model="usersFilter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!usersFilter" @click="usersFilter = ''">{{ $t('Clear') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-btn style="float:right;color:white;margin-bottom: 20px" variant="light" @click="getAvailableLicenses" v-b-modal.modal-create-user>{{ $t('Create User') }}</b-btn>
          </b-col>
        </b-row>
        <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 25px;">
          <b-spinner
            variant="secondary"
          ></b-spinner>
        </div>
        <b-table
          show-empty
          hover
          small
          responsive
          :items="users"
          :fields="userFields"
          :current-page="currentUserPage"
          :per-page="perPage"
          :filter="usersFilter"
          :filterIncludedFields="usersFilterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sort-compare="customCompare"
          @filtered="onUsersFiltered"
        >
          <template v-slot:empty="scope">
            <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
          </template>
          <template v-slot:cell(firstName)="row">
            <b-link class="nav-link" :to="{name: 'User', params: {id: row.item.id, tabIndex: tabIndex}}"> {{ row.item.firstName }} {{ row.item.lastName }} </b-link>
          </template>

          <template v-slot:cell(role)="row">
            <span v-if="row.item.role !== null">{{$t(row.item.role)}}</span>
            <span v-else>User</span>
          </template>

          <template v-slot:cell(groups)="row">
            <span> {{row.item.groups ? row.item.groups.length : 0}}</span>
          </template>

          <template v-slot:cell(status)="row">
            <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>
          </template>

          <template v-slot:cell(actions)="row" >
            <b-button variant="outline-dark" size="sm" @click="resetPasswordModal(row.item.id)">
              {{$t('Reset Password')}}
            </b-button>
            <b-button variant="outline-danger" size="sm" @click="removeUser(row.item)">
              {{$t('Remove')}}
            </b-button>
          </template>
        </b-table>
        <b-pagination
          v-model="currentUserPage"
          :total-rows="totalUserRows"
          :per-page="perPage"
          align="center"
          class="my-5"
        ></b-pagination>
      </div>
    </b-tab>
    <b-tab :title="$t('Licenses')" @click="fetchLicenses(false)" id="license">
      <div class="col-12 bg-white p-4 float-left">
        <b-row>
          <b-col lg="4" class="my-1">
            <b-form-group
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="licensesFilter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!licensesFilter" @click="licensesFilter = ''">{{ $t('Clear') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="8">
            <b-btn v-if="!selectLicences" style="float:right;color:white;margin-bottom: 20px" class="ml-2" variant="light" @click="selectLicences = true">{{$t('Select Licenses')}}</b-btn>
            <b-btn v-if="selectLicences" style="float:right;color:white;margin-bottom: 20px" class="ml-2" variant="danger" @click="selectLicences = false; selectedLicenses = []">{{$t('Cancel')}}</b-btn>
            <b-btn v-if="selectLicences" style="float:right;color:white;margin-bottom: 20px" class="ml-2" variant="light" @click="selectAllLicences">{{$t('Select all')}}</b-btn>

            <b-btn v-if="selectLicences" :disabled="selectedLicenses.length <= 0" style="float:right;color:white;margin-bottom: 20px" class="ml-2" variant="light" v-b-modal.modal-renew-multiple-licenses >{{$t('Renew')}} ({{selectedLicenses.length}})</b-btn>
            <b-btn style="float:right;color:white;margin-bottom: 20px" v-if="!selectLicences"  variant="light" v-b-modal.modal-new-licenses>{{$t('Create Licenses')}}</b-btn>
          </b-col>
        </b-row>
        <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 25px;">
          <b-spinner
            variant="secondary"
          ></b-spinner>
        </div>
        <b-table
          show-empty
          hover
          small
          responsive
          :items="licenses"
          :fields="licenseFields"
          :current-page="currentLicensePage"
          :per-page="perPage"
          :filter="licensesFilter"
          :filterIncludedFields="licenseFilterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sort-compare="customCompare"
          @filtered="onLicensesFiltered"
        >
          <template v-slot:empty="scope">
            <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
          </template>
          <template v-slot:cell(userName)="row">
            <b-link v-if="row.item.userName" class="nav-link" :to="'/users/'+row.item.userId"> {{ row.item.userName }} </b-link>
            <b-link v-else @click="fetchUnlicensedUsers(row.item)" v-b-modal.modal-user-to-license class="text-secondary">{{$t('Assign to User')}}</b-link>
          </template>
          <template v-slot:cell(remainingDays)="row">
            <label :class="row.item.expiresIn >= 30 ? '' :'text-danger'">{{ row.item.expiresIn }}</label>
          </template>
          <template v-slot:cell(type)="row">
             <span v-if="!row.item.hasOwnProperty('type')">{{$t('Regular User')}}</span>
            <span v-else>{{$t(row.item.type)}}</span>
          </template>

          <template v-slot:cell(actions)="row" >
            <b-button v-if="selectLicences === false" variant="outline-primary" size="sm" class=" btn mr-1" @click="setRenewVars(row.item.id, row.item.expiryDate) ">
              {{ $t('Renew')}}
            </b-button>
            <b-button v-if="selectLicences === false" variant="outline-danger" size="sm" @click="deleteLicense(row.item.id)">
              {{ $t('Remove')}}
            </b-button>
<!--            <input v-if="selectLicences === true" class="select-all-licences" type="checkbox" :value="row.item.id"  v-model="selectedLicenses">-->
            <b-checkbox
              class="select-all-licences"
              :value="row.item.id"
              v-model="selectedLicenses"
              v-if="selectLicences === true"
            >
            </b-checkbox>
          </template>
        </b-table>
        <b-pagination
          v-model="currentLicensePage"
          :total-rows="totalLicenseRows"
          :per-page="perPage"
          align="center"
          class="my-5"
        ></b-pagination>
      </div>
    </b-tab>
    <b-tab :title="$t('Details')" @click="fetchCompany()" style="padding: 0">
      <b-card class="col-md-12" >
        <p>
          <b-list-group flush>
            <b-list-group-item style="padding-left: 0">
              <b>{{$t('Administrator')}}:</b> <b-link class="nav-link d-inline-block" :to="'/users/'+company.admin"> {{ company.adminName }} </b-link>
            </b-list-group-item>
            <b-list-group-item style="padding-left: 0">
              <b>{{$t('Number Of Licenses')}}:</b> {{company.numberOfLicenses}}
            </b-list-group-item>
            <b-list-group-item style="padding-left: 0">
              <b>{{$t('Address')}}:</b> {{company.address}} <br>
              <b>{{$t('Postcode')}}:</b> {{company.postcode}}
            </b-list-group-item>
            <b-list-group-item style="padding-left: 0">
              <b>{{$t('Company Phone')}}:</b> {{company.phoneNumber}}
            </b-list-group-item>
            <b-list-group-item style="padding-left: 0">
              <b>{{$t('Company Phone')}} 2:</b> {{company.secondPhoneNumber}}
            </b-list-group-item>
            <b-list-group-item style="padding-left: 0">
              <b>{{$t('VAT Number')}}:</b> {{company.vat}}
            </b-list-group-item>
            <b-list-group-item style="padding-left: 0">
              <b>{{$t('Created At')}}:</b> {{company.createdAt}}
            </b-list-group-item>
          </b-list-group>
        </p>
      </b-card>
    </b-tab>
    <b-tab :title="$t('Settings')" @click="fetchCompanySettings" style="padding: 0">
      <b-card class="col-md-12" >
        <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 60px;">
          <b-spinner
            variant="secondary"
          ></b-spinner>
        </div>
        <h4>Company Settings</h4>
        <b-row class="pb-2 pt-2">
          <b-col md="3">
            <b-form-group
              :label="$t('Weight Unit')"
              label-for="name-input"
            >
              <b-form-select
                id="input-4"
                size="sm"
                v-model="companyPreferences.weightUnit"
                :options="[
                  {text: 'KILOGRAM', value: 'KILOGRAM'},
                  {text: 'LBS', value: 'LBS'},]"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="$t('Temperature Unit')"
              label-for="name-input"
            >
              <b-form-select
                id="input-4"
                size="sm"
                v-model="companyPreferences.temperatureUnit"
                :options="[
                  {text: 'CELSIUS', value: 'CELSIUS'},
                {text: 'FAHRENHEIT', value: 'FAHRENHEIT'}]"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="$t('Quantity Unit')"
              label-for="name-input"
            >
              <b-form-select
                id="input-4"
                size="sm"
                v-model="companyPreferences.quantityUnit"
                :options="[
                  {text: 'PIECES', value: 'PIECES'},
                  {text: 'BOXES', value: 'BOXES'},
                  {text: 'PACKAGES', value: 'PACKAGES'},
                  {text: 'PALETTES', value: 'PALETTES'},
                  ]"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="$t('Liquid Unit')"
              label-for="name-input"
            >
              <b-form-select
                id="input-4"
                size="sm"
                v-model="companyPreferences.liquidUnit"
                :options="[{text: 'LITER', value: 'LITER'},{text: 'GALLON', value: 'GALLON'}]"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <h5>Available Label Types</h5>
            <b-list-group class="available-label-types" v-if="labelTypes.length > 0">
                <b-list-group-item v-for="type in labelTypes" @click="addLabel(type.value)" v-bind:key="type.value"  button>{{type.label}}</b-list-group-item>
            </b-list-group>
            <span class="font-italic text-center" v-else>Empty List</span>
          </b-col>
          <b-col md="2" class="text-center pt-5">
            <b-btn variant="light" class="text-white" @click="addAll"><i style="font-size: 20px;" class="fa fa-angle-double-right"></i></b-btn>
            <i class="fa fa-arrows-h pt-3" style="font-size: 30px;display: block;"></i>
            <b-btn class="mt-3" @click="removeAll"><i style="font-size: 20px;" class="fa fa-angle-double-left"></i></b-btn>

          </b-col>
          <b-col md="5">
            <h5>Company Label Types</h5>
            <b-list-group class="selected-label-types" v-if="companyLabelTypes.length > 0">
              <b-list-group-item v-for="type in companyLabelTypes" @click="removeLabel(type.value)" v-bind:key="type.value" button>{{type.label}}</b-list-group-item>
            </b-list-group>
            <span class="font-italic text-center" v-else>Zero selected types</span>
          </b-col>
        </b-row>
        <b-row class="pt-2 pr-2 float-right">
          <b-btn style="float:right;color:white;margin-bottom: 20px" variant="light" @click="saveSettings">{{$t('Save')}}</b-btn>
        </b-row>
      </b-card>
    </b-tab>
  </b-tabs>
  <b-modal
    id="modal-reset-password"
    ref="modal"
    :title="$t('Reset Password')"
    @show="resetPasswordModalVars"
    @hidden="resetPasswordModalVars"
    @ok="resetPassword"
    okVariant="light"
    :ok-title-html="'<span style=color:white;>'+$t('Reset')+'</span>'"
    header-bg-variant="light"
    header-text-variant="white"
  >
    <form ref="form">
      <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
        <b-spinner
          variant="secondary"
        ></b-spinner>
      </div>
      <b-form-group
        :label="$t('New Password')"
        label-for="name-input"
      >
        <b-form-input
          type="password"
          id="group-name"
          v-model="resetPasswordData.password"
          :state="$v.resetPasswordData.password.$dirty ? !$v.resetPasswordData.password.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-5-live-feedback">
          <span v-if="!$v.resetPasswordData.password.required"> {{$t('Password is a required field')}}. </span>
          <span v-if="!$v.resetPasswordData.password.minLength"> {{$t('Password must have at least')}} {{ $v.resetPasswordData.password.$params.minLength.min }} {{$t('letters')}}.</span>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :label="$t('Repeat Password')"
        label-for="name-input"
      >
        <b-form-input
          type="password"
          id="group-name"
          v-model="resetPasswordData.repeatPassword"
          :state="$v.resetPasswordData.repeatPassword.$dirty ? !$v.resetPasswordData.repeatPassword.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-5-live-feedback">
          <span v-if="!$v.resetPasswordData.repeatPassword.sameAsPassword">{{$t('Passwords must be identical')}}.</span>
        </b-form-invalid-feedback>
      </b-form-group>
    </form>
  </b-modal>
  <b-modal
    id="modal-create-category"
    ref="modal"
    :title="$t('Create Category')"
    @show="resetModal"
    @hidden="resetModal"
    @ok="createCategory"
    okVariant="light"
    ok-title-html="<span style='color:white;'>Submit</span>"
    header-bg-variant="light"
    header-text-variant="white"
  >
    <form ref="form">
      <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
        <b-spinner
          variant="secondary"
        ></b-spinner>
      </div>
      <b-form-group
        :label="$t('Name of Category')"
        label-for="name-input"
      >
        <b-form-input
          id="group-name"
          v-model="newCategory.name"
          :state="$v.newCategory.name.$dirty ? !$v.newCategory.name.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-5-live-feedback">
         {{$t('Name is a required field')}}.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :label="$t('Contact Number')"
        label-for="name-input"
        style="width: 50%;float: left;padding-right: 10px"
      >
        <b-form-input
          id="group-name"
          v-model="newCategory.contactNumber"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :label="$t('VAT')"
        label-for="vat-input"
        style="width: 50%;float: left;"
      >
        <b-form-input
          id="vat-input"
          v-model="newCategory.vat"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :label="$t('Contact Email')"
        label-for="name-input"
      >
        <b-form-input
          id="group-name"
          v-model="newCategory.contactEmail"
        ></b-form-input>
        <b-form-invalid-feedback id="input-5-live-feedback">
          {{$t('Email field is a required field')}}.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :label="$t('Address')"
        label-for="name-input"
      >
        <b-form-textarea
          rows="4"
          no-resize
          id="name-input"
          type="text"
          v-model="newCategory.address"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group
        :label="$t('Notes')"
        label-for="notes-input"
      >
        <b-form-textarea
          rows="4"
          no-resize
          id="notes-input"
          type="text"
          v-model="newCategory.notes"
        ></b-form-textarea>
      </b-form-group>
    </form>
  </b-modal>
  <b-modal
    id="modal-create-user"
    ref="modal"
    :title="$t('Create User')"
    @show="resetUserModal"
    @hidden="resetUserModal"
    @ok="createUser"
    okVariant="light"
    ok-title-html="<span style='color:white;'>Submit</span>"
    header-bg-variant="light"
    header-text-variant="white"
  >

    <form ref="form">
      <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
        <b-spinner
          variant="secondary"
        ></b-spinner>
      </div>
      <b-form-group style="width: 50%;float:left;" id="input-group-2" :label="$t('First Name')" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="newUser.firstName"
          :state="$v.newUser.firstName.$dirty ? !$v.newUser.firstName.$error : null"
          required
          :placeholder="$t('First Name')"
        ></b-form-input>
        <b-form-invalid-feedback id="input-1-live-feedback">
          {{$t('This is a required field')}}.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group style="width: 50%;float:left;padding-left: 5px" id="input-group-6" :label="$t('Last Name')" label-for="input-22">
        <b-form-input
          id="input-22"
          v-model="newUser.lastName"
          :state="$v.newUser.lastName.$dirty ? !$v.newUser.lastName.$error : null"
          required
          placeholder="Last Name"
        ></b-form-input>
        <b-form-invalid-feedback id="input-2-live-feedback">
          {{$t('This is a required field')}}.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        id="input-group-1"
        :label="$t('Username/Email')"
        label-for="input-12"
        :description="$t('The Email/Username must be unique for every user.')"
      >
        <b-form-input
          id="input-12"
          v-model="customEmail"
          required
          autocomplete="new-password"
          :placeholder="$t('Enter Email or Username')"
          :state="$v.newUser.email.$dirty ? !$v.newUser.email.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-3-live-feedback">
         {{$t('This is a required field')}}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        id="input-group-1"
        :label="$t('Password')"
        label-for="input-1"
        :description="$t('Select a password for the User.')"
      >
        <b-form-input
          id="input-1"
          v-model="newUser.password"
          type="password"
          autocomplete="new-password"
          required
          :placeholder="$t('Enter Password')"
          :state="$v.newUser.password.$dirty ? !$v.newUser.password.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-4-live-feedback">
          {{$t('Email address is required and must be properly formatted.')}}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="input-group-99" :label="$t('Assign License')" label-for="input-99">
        <b-form-select
          id="input-99"
          size="sm"
          v-model="newUser.license"
          :options="availableLicenses"
          required
        ></b-form-select>
      </b-form-group>
      <b-form-group id="input-group-4" :label="$t('Status')" label-for="input-4">
        <b-form-select
          id="input-4"
          size="sm"
          v-model="newUser.status"
          :options="statuses"
          required
        ></b-form-select>
      </b-form-group>
    </form>
  </b-modal>
  <b-modal
    id="modal-new-licenses"
    ref="modal"
    :title="$t('Add new Licence')"
    @show="resetLicenseModal"
    @hidden="resetLicenseModal"
    @ok="submitLicences"
    okVariant="light"
    ok-title-html="<span style='color:white;'>Submit</span>"
    header-bg-variant="light"
    header-text-variant="white"
  >
    <form ref="form">
      <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 160px;">
        <b-spinner
          variant="secondary"
        ></b-spinner>
      </div>
      <b-form-group
        :label="$t('License Expiry Date')"
        label-for="name-input"
      >
        <b-form-input
          id="name-input"
          type="date"
          v-model="newLicense.expiryDate"
          :state="$v.newLicense.expiryDate.$dirty ? !$v.newLicense.expiryDate.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-5-live-feedback">
          {{$t('This is a required field')}}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :label="$t('Number of Licences')"
        label-for="name-input"
      >
        <b-form-input
          id="name-input"
          v-model="newLicense.quantity"
          :state="$v.newLicense.quantity.$dirty ? !$v.newLicense.quantity.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-5-live-feedback">
          {{$t('This is a required field. Must be greater than 0')}}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :label="$t('Licence Type')"
        label-for="name-input"
      >
        <b-form-select
          id="input-4"
          size="sm"
          v-model="newLicense.type"
          :options="licenseTypes"
        ></b-form-select>
      </b-form-group>
    </form>
  </b-modal>
  <b-modal
    id="modal-assign-manager"
    ref="modal"
    :title="$t('Assign User as Category Manager')"
    @show="resetAssignUserModal"
    @hidden="resetAssignUserModal"
    @ok="assignManager"
    okVariant="light"
    ok-title-html="<span style='color:white;'>Submit</span>"
    header-bg-variant="light"
    header-text-variant="white"
  >
    <form ref="form">
      <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
        <b-spinner
          variant="secondary"
        ></b-spinner>
      </div>
      <b-form-group @keydown.native.enter="assignManager" id="input-group-4" :label="$t('Select User:')" label-for="input-4">
        <b-form-select
          id="input-4"
          size="sm"
          v-model="assignManagerData.userId"
          value-field="managerId"
          text-field="managerName"
          :options="companyManagerUsers"
          :state="$v.assignManagerData.userId.$dirty ? !$v.assignManagerData.userId.$error : null"
        ></b-form-select>
        <b-form-invalid-feedback id="input-7-live-feedback">
          {{$t('This is a required field')}}
        </b-form-invalid-feedback>
      </b-form-group>
    </form>
  </b-modal>
  <b-modal
    id="modal-user-to-license"
    ref="modal"
    :title="$t('Assign License to a User')"
    @show="resetAssignUserModal"
    @hidden="resetAssignUserModal"
    @ok="assignLicense"
    okVariant="light"
    ok-title-html="<span style='color:white;'>Submit</span>"
    header-bg-variant="light"
    header-text-variant="white"
  >
    <form ref="form">
      <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
        <b-spinner
          variant="secondary"
        ></b-spinner>
      </div>
      <b-form-group @keydown.native.enter="assignLicense" id="input-group-4" :label="$t('Select User:')" label-for="input-4">
        <b-form-select
          id="input-4"
          size="sm"
          v-model="assignLicenseData.userId"
          :options="unlicensedUsers"
          :state="$v.assignLicenseData.userId.$dirty ? !$v.assignLicenseData.userId.$error : null"
        ></b-form-select>
        <b-form-invalid-feedback id="input-7-live-feedback">
          {{$t('This is a required field')}}
        </b-form-invalid-feedback>
      </b-form-group>
    </form>
  </b-modal>
  <b-modal
    id="modal-renew-multiple-licenses"
    ref="modal"
    :title="$t('Renew Licences')"
    @ok="renewLicenses"
    @hidden="resetRenewModal"
    okVariant="light"
    ok-title-html="<span style='color:white;'>Submit</span>"
    header-bg-variant="light"
    header-text-variant="white"
  >
    <form ref="form">
      <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 100px;">
        <b-spinner
          variant="secondary"
        ></b-spinner>
      </div>
      <b-form-group
        :label="$t('Renew Date')"
        label-for="name-input"
      >
        <b-form-input
          id="name-input"
          type="date"
          v-model="renewLicenseForm.renewDate"
          :state="$v.renewLicenseForm.renewDate.$dirty ? !$v.renewLicenseForm.renewDate.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-5-live-feedback">
          {{$t('This is a required field')}}.
        </b-form-invalid-feedback>
      </b-form-group>
    </form>
  </b-modal>
  <b-modal
    id="modal-renew-license"
    ref="modal"
    :title="$t('Renew Licence')"
    @show="resetRenewModal"
    @hidden="resetRenewModal"
    @ok="renewLicense"
    okVariant="light"
    ok-title-html="<span style='color:white;'>Submit</span>"
    header-bg-variant="light"
    header-text-variant="white"
  >
    <form ref="form">
      <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 100px;">
        <b-spinner
          variant="secondary"
        ></b-spinner>
      </div>
      <h4>{{$t('License Last Expiry Date')}}: {{licensedExpiredOn}}</h4>
      <b-form-group
        :label="$t('Renew Date')"
        label-for="name-input"
      >
        <b-form-input
          id="name-input"
          type="date"
          v-model="renewLicenseForm.renewDate"
          :state="$v.renewLicenseForm.renewDate.$dirty ? !$v.renewLicenseForm.renewDate.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-5-live-feedback">
          {{$t('This is a required field')}}.
        </b-form-invalid-feedback>
      </b-form-group>
    </form>
  </b-modal>
  <b-modal
    id="modal-edit-category"
    ref="modal"
    :title="$t('Edit Category')"
    @show="resetCategoryModal"
    @hidden="resetCategoryModal"
    @ok="saveCategory"
    okVariant="light"
    ok-title-html="<span style='color:white;'>Save</span>"
    header-bg-variant="light"
    header-text-variant="white"
  >
    <form ref="form">
      <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 60px;">
        <b-spinner
          variant="secondary"
        ></b-spinner>
      </div>
      <b-form-group
        :label="$t('Name')"
        label-for="name-input"
      >
        <b-form-input
          id="name-input"
          type="text"
          v-model="categoryData.name"
          :state="$v.categoryData.name.$dirty ? !$v.categoryData.name.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback id="input-5-live-feedback">
          {{$t('This is a required field')}}.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group  id="input-group-4" :label="$t('Managers')" label-for="input-4">
        <multiselect v-model="categoryData.managers" :groupSelect="false" :optionHeight="10" :showLabels="false" deselectLabel="" selectLabel="" :options="companyManagerUsers" :multiple="true" :close-on-select="false" :searchable="false" :clear-on-select="false" :taggable="false" :preserve-search="false" :placeholder="$t('Select Manager')" label="managerName" track-by="managerId" :preselect-first="false">
          <!--<template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>-->
        </multiselect>
        <!--<b-form-select-->
          <!--id="input-4"-->
          <!--size="sm"-->
          <!--v-model="categoryData.manager"-->
          <!--:options="companyManagerUsers"-->
          <!--:state="$v.categoryData.manager.$dirty ? !$v.categoryData.manager.$error : null"-->
        <!--&gt;</b-form-select>-->
        <b-form-invalid-feedback id="input-7-live-feedback">
          {{$t('This is a required field')}}.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :label="$t('Contact Number')"
        label-for="name-input"
        style="width: 50%;float: left;padding-right: 10px"
      >
        <b-form-input
          id="name-input"
          type="tel"
          v-model="categoryData.contactNumber"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :label="$t('VAT')"
        label-for="name-input"
        style="width: 50%;float: right"
      >
        <b-form-input
          id="name-input"
          type="tel"
          v-model="categoryData.vat"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :label="$t('Contact Email')"
        label-for="name-input"
      >
        <b-form-input
          id="group-name"
          v-model="categoryData.contactEmail"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :label="$t('Address')"
        label-for="name-input"
      >
        <b-form-textarea
          rows="4"
          no-resize
          id="name-input"
          type="text"
          v-model="categoryData.address"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group
        :label="$t('Notes')"
        label-for="name-input"
      >
        <b-form-textarea
          rows="4"
          no-resize
          id="name-input"
          type="text"
          v-model="categoryData.notes"
        ></b-form-textarea>
      </b-form-group>
    </form>
  </b-modal>
</div>
</template>
<script>
import moment from 'moment'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import Devices from './Devices'
export default {
  name: 'SysCompany',
  components: {Devices},
  data () {
    return {
      selectLicences: false,
      selectedLicenses: [],
      companyPreferences: {
        liquidUnit: 'LITER',
        quantityUnit: 'PIECES',
        temperatureUnit: 'CELSIUS',
        weightUnit: 'KILOGRAM'
      },
      companyLabelTypes: [],
      customEmail: '',
      availableLicenses: [],
      categoryData: {
        name: null,
        managers: []
      },
      activeUsers: [{text: this.$t('Select User'), value: null}],
      /* eslint-disable */
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      tabIndex: 0,
      resetPasswordData: {
        password: '',
        repeatPassword: ''
      },
      loading: false,
      renewLicenseForm: {
        companyId: null,
        renewLicenseId: null,
        renewDate: moment().add(1, 'year').format('YYYY-MM-DD')
      },
      licensedExpiredOn: null,
      newCategory: {
        numberOfGroups: 0,
        name: '',
        contactNumber: '',
        address: '',
        contactEmail: ''
      },
      users: [],
      categories: [],
      licenses: [],
      licenseFilterOn: [],
      filterOn: [],
      usersFilterOn: [],
      sortDesc: false,
      sortBy: '',
      sortDirection: 'asc',
      licensesFilter: null,
      usersFilter: null,
      filter: null,
      groups: [],
      companyManagerUsers: [],
      companyUsers: [{text: this.$t('Select User'), value: null}],
      unlicensedUsers: [{text: this.$t('Select User'), value: null}],
      assignManagerData: {
        userId: null
      },
      assignLicenseData: {
        userId: null,
        licenseType: null
      },
      company: {
        numberOfLicenses: null,
        name: null,
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        role: null,
        status: 'Active'
      },
      newUser: {
        email: null,
        firstName: null,
        lastName: null,
        password: null,
        companyId: null,
        license: null,
        status: 'Inactive',
        role: null
      },
      newLicense: {
        quantity: 1,
        expiryDate: moment().add(1, 'year').format('YYYY-MM-DD'),
        type: null
      },
      licenseTypes: [{text: this.$t('Regular User'), value: null}, {text: this.$t('Manager'), value: 'Manager'},  {text: this.$t('Supervisor'), value: 'Supervisor'}],
      roles: [{ text: this.$t('Select Role'), value: null }, { text: this.$t('System Admin'), value: 'System Admin' }, { text: this.$t('Administrator'), value: 'Administrator' }],
      statuses: [{text: this.$t('Active'), value: 'Active'}, {text: this.$t('Inactive'), value: 'Inactive'}],

      show: true,
      totalRows: 1,
      totalLicenseRows: 1,
      totalUserRows: 1,
      currentPage: 1,
      currentLicensePage: 1,
      currentUserPage: 1,
      perPage: 15,
      pageOptions: [5, 10, 15]
    }
  },
  validations: {
    newCategory: {
      name: {
        required
      }
    },
    newUser: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required
      },
      password: {
        required,
        minLength: minLength(6)
      }
    },
    resetPasswordData: {
      password: {
        required,
        minLength: minLength(6)
      },
      repeatPassword: {
        sameAsPassword: sameAs('password')
      }
    },
    newLicense: {
      expiryDate: {
        required
      },
      quantity: {
        required,
        minValue: 1,
        maxValue: 30
      }
    },
    assignManagerData: {
      userId: {
        required
      }
    },
    assignLicenseData: {
      userId: {
        required
      }
    },
    renewLicenseForm: {
      renewDate: {
        required
      }
    },
    categoryData: {
      name: {
        required
      },
      manager: {
        required
      }
    }
  },
  mounted () {
    if (this.$route.params.licensesCategory) {
      this.$store.state.licensesCategory = this.$route.params.licensesCategory
    }

    this.groups = []
    this.company = this.$store.state.companies.find(m => m.id === this.$route.params.id)
    if (!this.company.id) {
      this.fetchCompany()
    } else {
      this.loadTabContent()
    }

  },
  computed: {
    labelTypes () {
      return [
        { value: 'LABELLING', label: this.$t('LABELLING') },
        { value: 'TEMPERATURE', label: this.$t('TEMPERATURE') },
        { value: 'BLAST_CHILLER', label: this.$t('BLAST_CHILLER') },
        { value: 'ALLERGEN', label: this.$t('ALLERGEN') },
        { value: 'QUANTITIES', label: this.$t('QUANTITIES') },
        { value: 'INGREDIENTS', label: this.$t('INGREDIENTS') },
        { value: 'FREE_NOTES', label: this.$t('FREE_NOTES') },
        { value: 'USE_FIRST', label: this.$t('USE_FIRST') },
        { value: 'FORMS', label: this.$t('FORMS') },
        { value: 'DEVICES', label: this.$t('DEVICES') }
      ]
    },
    fields () {
      return [
        {key: 'id', label: this.$t('Category Name'), sortable: true, sortDirection: 'desc', class: 'text-left'},
        {key: 'managers', label: this.$t('Managers'), sortable: true, class: 'text-center'},
        {key: 'contactNumber', label: this.$t('Contact Number'), sortable: false, class: 'text-center'},
        {key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center'},
        {key: 'actions', label: this.$t('Actions'), class: 'text-center'}
      ]
    },
    userFields () {
      return [
        {key: 'firstName', label: this.$t('User Name'), sortable: true, sortDirection: 'desc', class: 'text-left'},
        {key: 'role', label: this.$t('Role'), sortable: true, class: 'text-center'},
        {key: 'groups', label: this.$t('Groups'), sortable: true, class: 'text-center'},
        {key: 'status', label: this.$t('Status'), sortable: true, class: 'text-center'},
        {key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center'},
        {key: 'actions', label: this.$t('Actions'), class: 'text-center'}
      ]
    },
    licenseFields () {
      return [
        {key: 'userName', label: this.$t('Assigned User'), sortable: false},
        {key: 'expiryDate', label: this.$t('Expires On'), sortable: true, class: 'text-center'},
        {key: 'remainingDays', label: this.$t('Remaining Days'), sortable: false,  class: 'text-center'},
        {key: 'type', label: this.$t('Type'), sortable: true},
        {key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center'},
        {key: 'actions', label: this.$t('Actions'), class: 'text-center'}
      ]
    }
  },
  methods: {
    customCompare (a, b, key) {
      if (['createdAt'].includes(key)) {
        var aDate = moment(a[key], 'DD/MM/YYYY kk:mm')
        var bDate = moment(b[key], 'DD/MM/YYYY kk:mm')
        if (aDate.isValid && bDate.isValid) {
          if (aDate < bDate) {
            return -1
          } else if (aDate > bDate) {
            return 1
          } else {
            return 0
          }
        }
        return null
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false
      }
    },
    addAll () {
      var self = this
      this.labelTypes.forEach((type, index) => {
        self.companyLabelTypes.push(type)
      })
      self.labelTypes.splice(0,self.labelTypes.length)
    },
    removeAll () {
      var self = this
      this.companyLabelTypes.forEach((type, index) => {
        self.labelTypes.push(type)
      })
      self.companyLabelTypes.splice(0,self.companyLabelTypes.length)
    },
    addLabel (type) {
      var index = this.labelTypes.findIndex(t => t.value === type)
      this.labelTypes.splice(index, 1)
      this.companyLabelTypes.push({value: type, label: this.$t(type)})
    },
    removeLabel (type) {
      var index = this.companyLabelTypes.findIndex(t => t.value === type)
      this.companyLabelTypes.splice(index, 1)
      this.labelTypes.push({value: type, label: this.$t(type)})
    },
    saveSettings () {
      var self = this
      this.$bvModal.msgBoxConfirm(self.$t('You are about to update Settings.'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'light',
          okTitle: self.$t('Confirm'),
          centered: true
        })
        .then(value => {

          if (value) {
            self.loading = true
            var arrayLabelTypes = []

            this.companyLabelTypes.forEach( type => {
              arrayLabelTypes.push(type.value)
            })


            var data = self.companyPreferences
            data.labelTypes = arrayLabelTypes
            data.companyId = this.$route.params.id
            console.log(arrayLabelTypes)
            const saveSettings = this.$firebase.functions().httpsCallable('saveCompanySettings')
            saveSettings(data).then(function (result) {
              // success or error handling
              console.log('result', result)
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.$swal({
                  title: self.$t('Changes Saved!'),
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
              self.loading = false
            })
          }
        })
    },
    fetchCompanySettings () {
      var self = this
      if (this.companyLabelTypes.length == 0) {
        this.$store.dispatch('fetchCompanyPreferences', this.$route.params.id).then(preferences => {
          preferences.labelTypes.forEach(type => {
            var index = self.labelTypes.findIndex(t => t.value === type)
            console.log(index, self.labelTypes)
            if (index > -1) {
              self.labelTypes.splice(index, 1)
            }
            self.companyLabelTypes.push({value: type, label: self.$t(type)})
          })

          if(preferences.hasOwnProperty("liquidUnit")) {
            self.companyPreferences.liquidUnit = preferences.liquidUnit
          }
          if(preferences.hasOwnProperty("quantityUnit")) {
            self.companyPreferences.quantityUnit = preferences.quantityUnit
          }
          if(preferences.hasOwnProperty("temperatureUnit")) {
            self.companyPreferences.temperatureUnit = preferences.temperatureUnit
          }
          if(preferences.hasOwnProperty("weightUnit")) {
            self.companyPreferences.weightUnit = preferences.weightUnit
          }
        })
      }
    },
    async fetchCompany () {
      let self = this
      await this.$firebase.firestore().doc('companies/' + this.$route.params.id).get()
        .then(async function (doc) {
          var companyData = doc.data()
          self.company.numberOfLicenses = companyData.numberOfLicenses
          self.company.vat = companyData.vat
          self.company.secondPhoneNumber = companyData.secondPhoneNumber
          self.company.phoneNumber = companyData.phoneNumber
          self.company.postcode = companyData.postcode
          self.company.address = companyData.address
          if (self.company.createdAt != null) {
            self.company.createdAt = moment(String(companyData.createdAt.toDate())).format('DD/MM/YYYY')
          }
          if (self.company.admin) {
            var index = self.users.findIndex(u => u.id === self.company.admin)
            if (index !== -1) {
              self.company.adminName = self.users[index].firstName + ' ' + self.users[index].lastName
            } else {

              var admin = await self.$firebase.firestore().collection('users').doc(self.company.admin).get()
                .then(doc => {
                  return doc.data()
                })
              if (admin) {
                self.company.adminName = admin.firstName + ' ' + admin.lastName
              }
            }
          }

          self.company.id = doc.id
        })
    },
    loadTabContent () {
      if (this.$store.state.tabIndex) {
        console.log("tabIndex", this.$store.state.tabIndex)
        this.tabIndex = this.$store.state.tabIndex
        this.$store.state.tabIndex = 0
      }
      console.log("tabIndex", this.tabIndex)

      switch (this.tabIndex) {
        case 0:
          this.fetchCategories(false)
          break
        case 1:
          this.fetchUsers()
          break
        case 2:
          this.fetchLicenses()
          break
        default:
          this.fetchCategories(false)
      }
    },
    selectAllLicences(){
      console.log("this.licenses", this.licenses)
      // select-all-licences
      // let checkboxes = document.getElementsByClassName('select-all-licences')

      // console.log("checkboxes", checkboxes)
      // for (var i = 0; i < checkboxes.length; i++) {
      //   console.log('fakeImage: ', checkboxes[i]);
      //   checkboxes[i].setAttribute("checked", "checked");
      // }

      this.selectedLicenses = this.licenses.map(a => a.id);
    },
    submitLicences (e) {
      e.preventDefault()

      this.$v.newLicense.$touch()
      if (this.$v.newLicense.$anyError) {
        return
      }
      this.loading = true
      let self = this
      this.newLicense.companyName = self.company.name
      this.newLicense.companyId = self.company.id

      const createLicenses = this.$firebase.functions().httpsCallable('createLicenses')
      console.log('this.newLicense', this.newLicense)
      createLicenses(this.newLicense).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.fetchLicenses(true)
          self.$swal({
            title: self.$t('Licences Created!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    getCompanyUsers (categoryId = null) {
      // setting selected category
      if (categoryId){
        this.assignManagerData.categoryId = categoryId
      }
      var self = this
      this.$firebase.firestore().collection('users').where('companyId', '==', self.$route.params.id).where('role', '==', 'Manager').get().then(function (users) {
        self.companyUsers = []
        users.forEach(function (user) {
          var userData = user.data()
          var name = userData.firstName + ' ' + userData.lastName
          self.companyManagerUsers.push({managerId: user.id, managerName: name})
        })
      })
    },
    getCompanyManagerUsers (categoryId = null) {
      // setting selected category
      if (categoryId){
        this.assignManagerData.categoryId = categoryId
      }
      var self = this
      this.$firebase.firestore().collection('users').where('companyId', '==', self.$route.params.id).where('role', '==', 'Manager').get().then(function (users) {
        self.companyManagerUsers = []
        users.forEach(function (user) {
          console.log(user.data())
          var userData = user.data()
          var name = userData.firstName + ' ' + userData.lastName
          self.companyManagerUsers.push({managerId: user.id, managerName: name})
        })
      })
    },
    fetchUnlicensedUsers (license) {
      // setting selected license
      this.assignLicenseData.licenseId = license.id
      if (license.hasOwnProperty('type')) {
        this.assignLicenseData.type = license.type
      }
      var self = this
      this.$firebase.firestore().collection('users').where('companyId', '==', self.$route.params.id).get().then(function (users) {
        self.unlicensedUsers = [{text: self.$t('Select User'), value: null}]
        users.forEach(function (user) {
          var userData = user.data()
          var name = userData.firstName + ' ' + userData.lastName

          var userLicenseIndex = self.licenses.findIndex(l => l.userId === user.id)
          if (userLicenseIndex === -1){
            self.unlicensedUsers.push({value: user.id, text: name})
          }
        })
      })
    },
    isEmailValid: function(email) {
      return this.reg.test(email);
    },
    createUser (e) {
      e.preventDefault()

      this.newUser.email = this.customEmail
      this.$v.newUser.$touch()
      if (this.$v.newUser.$anyError) {
        return
      }

      if(!this.isEmailValid(this.customEmail)) {
        this.newUser.email = this.customEmail + '@yescheflabel.com'
      }

      this.loading = true
      let self = this

      self.newUser.companyId = this.$route.params.id
      const createCompanyUser = this.$firebase.functions().httpsCallable('createSingleUser')
      createCompanyUser(this.newUser).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.fetchUsers(true)
          self.$swal({
            title: self.$t('User Created!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      if (this.form.role === 'Administrator') {
        const createUser = this.$firebase.functions().httpsCallable('createUser')
        createUser(this.form).then(function (result) {
          // success or error handling
          if (result.data) {
          }
        })
      } else {
        // this.createUser()
      }

      // create User and Authenticate user
    },
    fetchCategories (bypass = false) {
      var self = this
      if (self.categories.length === 0 || bypass) {
        this.categories = []
        var categories = this.$firebase.firestore().collection('companies').doc(this.$route.params.id).collection('categories')
        categories.orderBy('createdAt', 'asc').get().then(function (querySnapshot) {
          querySnapshot.forEach(async function (doc) {
            var groupData = doc.data()
            groupData.id = doc.id
            if (!groupData.hasOwnProperty('name')) {
              groupData.name = doc.id
            }
            if (groupData.createdAt != null) {
              groupData.createdAt = moment(String(groupData.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
            }
            self.categories.push(groupData)
          })
        })
      }
    },
    fetchUsers (fakePass = false) {
      var self = this
      if (self.users.length === 0 || fakePass) {
        self.users = []
        var users = this.$firebase.firestore().collection('users').where('companyId', '==', this.company.id).orderBy("firstName", "asc").orderBy("lastName", "asc")
        users.get().then(function (querySnapshot) {
          querySnapshot.forEach(async function (doc) {
            var userData = doc.data()
            userData.id = doc.id
            if (userData.createdAt != null) {
              userData.createdAt = moment(String(userData.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
            }
            self.users.push(userData)
          })
          self.onUsersFiltered(self.users)
        })
      }
    },
    resetPasswordModal (uid) {
      this.$bvModal.show('modal-reset-password')
      this.resetPasswordData.user = uid
    },
    resetPassword (e) {
      e.preventDefault()
      var self = this
      this.$v.resetPasswordData.$touch()
      if (this.$v.resetPasswordData.$anyError) {
        return
      }
      this.loading = true
      const resetPassword = this.$firebase.functions().httpsCallable('resetPassword')
      resetPassword(this.resetPasswordData).then(function (result) {
        // success or error handling
        if (!result.data.uid) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('Password changed!'),
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    resetPasswordModalVars() {
      this.resetPasswordData.password = ''
      this.resetPasswordData.repeatPassword = ''
      this.$v.$reset()
    },
    fetchLicenses (fakePass = false) {
      var self = this
      if (self.licenses.length === 0 || fakePass) {
        self.licenses = []
        var licenses = this.$firebase.firestore().collection('companies').doc(this.$route.params.id).collection('licenses')
        licenses.get().then(function (querySnapshot) {
          querySnapshot.forEach(async function (doc) {
            var licenseData = doc.data()
            licenseData.id = doc.id
            if (licenseData.createdAt != null) {
              licenseData.createdAt = moment(String(licenseData.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
            }
            if (licenseData.expiryDate != null) {
              var expiration = moment(licenseData.expiryDate.toDate(), 'DD/MM/YYY')
              var currentDate = moment()
              licenseData.expiresIn = moment(expiration).diff(currentDate, 'days')
              licenseData.expiryDate = moment(String(licenseData.expiryDate.toDate())).format('DD/MM/YYYY')

            }
            self.licenses.push(licenseData)
          })
          self.onLicensesFiltered(self.licenses)
        })
      }
    },
    getAvailableLicenses () {
      var self = this
      var licenses = this.$firebase.firestore().collection('companies').doc(this.$route.params.id).collection('licenses')
      licenses.get().then(function (querySnapshot) {
        self.availableLicenses = [{text: self.$t('Select License'), value: null}]
        querySnapshot.forEach(function (doc) {
          if (doc.data().userId == null){
            var licenseData = doc.data()

            var licenseText = ''
            if(licenseData.hasOwnProperty('type') && licenseData.type != null){
              licenseText = licenseData.type
            } else {
              licenseText = "User"
            }
            licenseText += ' ' + moment(String(licenseData.expiryDate.toDate())).format('DD/MM/YYYY kk:mm').toString()

            self.availableLicenses.push({value: doc.id, text: licenseText})
          }
        })
      })
    },
    removeManager (categoryId, managerId, managerName) {
      var self = this
        this.$bvModal.msgBoxConfirm(self.$t('removeManagerFromCategoryWarning'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: self.$t('Confirm'),
          centered: true
        })
        .then(value => {

          if (value) {
            self.loading = true
            const deleteCat = this.$firebase.functions().httpsCallable('removeManager')
            deleteCat({categoryId: categoryId, managerId: managerId, managerName: managerName,  companyId: this.$route.params.id}).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.fetchCategories(true)
                self.$swal({
                  title: self.$t('Manager Removed!'),
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                }).then(function (result) {
                  self.$refs.modal.hide()
                })
              }
              self.loading = false
            })
          }
        })
    },
    assignManager (e) {
      e.preventDefault()
      var self = this
      this.$v.assignManagerData.$touch()
      if (this.$v.assignManagerData.$anyError) {
        return
      }
      this.loading = true

      var user = this.companyManagerUsers.find(m => m.managerId === this.assignManagerData.userId)
      this.assignManagerData.userName = user.managerName
      this.assignManagerData.companyId = this.$route.params.id
      const assignManager = this.$firebase.functions().httpsCallable('assignManagerToGroup')
      assignManager(this.assignManagerData).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.fetchCategories(true)
          self.$swal({
            title: self.$t('Manager Added!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    assignLicense (e) {
      e.preventDefault()
      var self = this
      this.$v.assignLicenseData.$touch()
      if (this.$v.assignLicenseData.$anyError) {
        return
      }
      this.loading = true

      var user = this.unlicensedUsers.find(m => m.value === this.assignLicenseData.userId)
      this.assignLicenseData.userName = user.text
      this.assignLicenseData.companyId = this.$route.params.id
      const assignLicense = this.$firebase.functions().httpsCallable('assignLicenseToUser')
      assignLicense(this.assignLicenseData).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.fetchLicenses(true)
          self.users = []
          self.$swal({
            title: self.$t('User Activated!'),
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    resetModal () {
      this.newCategory.name = ''
      this.newCategory.contactNumber = ''
      this.newCategory.contactEmail = ''
      this.newCategory.notes = ''
      this.newCategory.vat = ''
      this.newCategory.address = ''
      this.$v.$reset()
    },
    resetAssignUserModal () {
      this.assignManagerData.userId = ''
      this.$v.$reset()
    },
    resetLicenseModal () {
      this.newLicense.expiryDate = moment().add(1, 'year').format('YYYY-MM-DD')
      this.newLicense.quantity = 1
      this.$v.$reset()
    },
    resetUserModal () {
      this.newUser.email = ''
      this.newUser.firstName = null
      this.newUser.password = ''
      this.newUser.lastName = null
      this.$v.$reset()
    },
    onFiltered (filteredItems) {
      //
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onUsersFiltered (filteredItems) {
      //
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalUserRows = filteredItems.length
      this.currentUserPage = 1
    },
    onLicensesFiltered (filteredItems) {
      //
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalLicenseRows = filteredItems.length
      this.currentLicensePage = 1
    },
    createCategory (e) {
      e.preventDefault()

      this.$v.newCategory.$touch()
      if (this.$v.newCategory.$anyError) {
        return
      }
      this.loading = true
      let self = this
      const createCategory = this.$firebase.functions().httpsCallable('createCategory')
      this.newCategory.companyId = this.$route.params.id
      createCategory(this.newCategory).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('Category Created!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.fetchCategories(true)
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    fetchActiveUsers (id) {
      // setting selected license
      var self = this
      this.$firebase.firestore().collection('users').where('status', '==', 'Active').where('companyId', '==', id).get().then(function (users) {
        self.activeUsers = [{text: self.$t('Select Manager'), value: null}]
        users.forEach(function (user) {
          var userData = user.data()
          var name = userData.firstName + ' ' + userData.lastName
          self.activeUsers.push({value: user.id, text: name})
        })
      })
    },
    setRenewVars (id, expiryDate) {
      this.$bvModal.show('modal-renew-license')
      this.renewLicenseForm.renewLicenseId = id
      this.renewLicenseForm.companyId = this.$route.params.id
      this.licensedExpiredOn = expiryDate
    },
    resetRenewModal () {
      this.renewLicenseForm.renewDate = moment().add(1, 'year').format('YYYY-MM-DD')
      this.selectedLicenses = []
      this.$v.$reset()
    },
    renewLicenses (e) {
      e.preventDefault()
      this.$v.renewLicenseForm.$touch()
      if (this.$v.renewLicenseForm.$anyError) {
        return
      }
      this.loading = true
      let self = this

      const payLoad = {
        licences: this.selectedLicenses,
        companyId: this.$route.params.id,
        renewDate: this.renewLicenseForm.renewDate
      }

      const renewLicense = this.$firebase.functions().httpsCallable('renewLicenses')
      renewLicense(payLoad).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.fetchLicenses(true)
          self.selectLicences = false
          self.$swal({
            title: self.$t('Licences Renewed!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    renewLicense (e) {
      e.preventDefault()
      this.$v.renewLicenseForm.$touch()
      if (this.$v.renewLicenseForm.$anyError) {
        return
      }
      this.loading = true
      let self = this

      const renewLicense = this.$firebase.functions().httpsCallable('renewLicense')
      renewLicense(this.renewLicenseForm).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.fetchLicenses(true)
          self.$swal({
            title: self.$t('Licence Renewed!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    editCategory (item) {
      this.getCompanyManagerUsers(item.id)
      var cg = this.categories.find(c => c.id === item.id)
      console.log('category', cg)
      this.categoryData.id = cg.id
      this.categoryData.name = cg.name
      this.categoryData.companyId = this.$route.params.id
      this.categoryData.managers = cg.managers
      this.categoryData.contactNumber = cg.contactNumber
      this.categoryData.contactEmail = cg.contactEmail
      this.categoryData.address = cg.address
      this.categoryData.vat = cg.vat
      this.categoryData.notes = cg.notes
      this.$bvModal.show('modal-edit-category')
    },
    saveCategory (e) {
      e.preventDefault()
      var self = this
      this.loading = true
      // if (self.categoryData.manager && !self.categoryData.managerName) {
      //   this.categoryData.managerName = this.companyUsers.find(u => u.value === self.categoryData.manager).text
      // } else {
      //   this.categoryData.managerName = null
      // }
      console.log('categoryData', this.categoryData)
      const updateCat = this.$firebase.functions().httpsCallable('updateCategory')
      updateCat(this.categoryData).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.fetchCategories(true)
          self.$swal({
            title: self.$t('Category Updated!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })

    },
    async deleteCategory (item, index) {
      var self = this
      var groupInCategory = await this.$firebase.firestore().collectionGroup('groups').where('category', '==', item.id).limit(1).get().then( data => {
        return data.size
      })

      if (groupInCategory){
        self.$swal({
          title: self.$t('Cannot Delete Category!'),
          text: self.$t('It seems that the category has groups. You have to delete all groups first'),
          type: 'error',
          timer: 0,
          showConfirmButton: true
        })
        return
      }

      this.$bvModal.msgBoxConfirm(self.$t('deleteCategoryWarning'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: self.$t('Confirm'),
          centered: true
        })
        .then(value => {

          if (value) {
            self.loading = true
            const deleteCat = this.$firebase.functions().httpsCallable('deleteCategory')
            deleteCat({id: item.id, companyId: this.$route.params.id}).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.fetchCategories(true)
                self.$swal({
                  title: self.$t('Category Removed!'),
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                }).then(function (result) {
                  self.$refs.modal.hide()
                })
              }
              self.loading = false
            })
          }
        })
    },
    resetCategoryModal () {

    },
    deleteLicense (id) {
      var self = this
      this.$bvModal.msgBoxConfirm(self.$t('You are about to delete this license. This action cannot be undone.'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: 'Confirm',
          centered: true
        })
        .then(value => {
          self.loading = true
          if (value) {
            const deleteLicense = self.$firebase.functions().httpsCallable('deleteLicense')
            deleteLicense({id: id, companyId: self.$route.params.id}).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.fetchLicenses(true)
                self.$swal({
                  title: self.$t('Licence Deleted!'),
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                }).then(function (result) {
                  self.$refs.modal.hide()
                })
              }
              self.loading = false
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    removeUser (item) {
      var self = this
      this.$swal({
        title: self.$t('Are you sure?'),
        text: self.$t('Deleting this user cannot be undone!'),
        showConfirmButton: true,
        showCancelButton: true
      }).then(function (value) {
        if (value.value) {
          self.loading = true
          const removeUser = self.$firebase.functions().httpsCallable('deleteUser')
          removeUser({id: item.id, companyId: self.$route.params.id}).then(function (result) {
            // success or error handling
            // console.log(result)
            // if (result.data) {
            self.$swal({
              title: self.$t('User Deleted!'),
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
            self.fetchUsers(true)
            self.licenses = []
            // }
            self.loading = false
          })
        }
      })
    },
  }
}
</script>

<style>
  #groups .group-box {
    float: left;
    cursor: pointer;
  }

  #groups .card-header, #groups .card-body {
    margin-left: 15px;
    margin-right: 15px;
    background-color: #003e53;
  }

  #groups .group-box-category{
    position: absolute;
    top: -9px;
    left: 25px;
    background: #003e53;
    /* border: 1px solid; */
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    padding-left: 4px;
    padding-right: 4px;
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Company.vue